/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diet_VegetarianInputs */

const en_diet_vegetarian = /** @type {(inputs: Diet_VegetarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vegetarian`)
};

const de_diet_vegetarian = /** @type {(inputs: Diet_VegetarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vegetarisch`)
};

/**
* | output |
* | --- |
* | "Vegetarian" |
*
* @param {Diet_VegetarianInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diet_vegetarian = /** @type {((inputs?: Diet_VegetarianInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diet_VegetarianInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_diet_vegetarian(inputs)
	return en_diet_vegetarian(inputs)
});